<div class="gaugeContainer">
  <img class="gaugeSvg" [src]="smileyValue ? '../../../assets/img/gauge/gauge.svg' : '../../../assets/img/gauge/gaugeWithoutSmiley.svg'" alt="Gauge for NPS" />
  <div [style.transform]="'rotate(' + mapValueToRange(needleData) + 'deg)'" class="gauge-needle-container">
    <img class="gauge-needle-img" src="../../../assets/img/gauge/gaugeNeedle.svg" alt="Gauge needle" />
  </div>
</div>
